import { __assign, __awaiter, __generator } from "tslib";
import { fetchFeatureGates, getFeatureGates, } from '@office-start/feature-gates-service';
import { fetchIdentity, getOfficeIdentity, } from '@office-start/identity-service';
import { logFeature, logPerformance } from '@office-start/telemetry-service';
import { getLocation, getQueryParams } from '@office-start/url-parser-utility';
// Global constants to be added in all the copilot funnel logging events
var copilotFunnelLoggingEnabled = true;
var userData = {
    aadId: '',
    tenantId: '',
};
export var PinnedSelectionTypes = {
    PinAndContinue: 'Pin and Continue',
    AskMeLater: 'Ask me later',
    Decline: 'Decline',
    Continue: 'Continue',
};
export var FreNotShownReasons = {
    ErrorInFetchingUserCopilotFreData: 'Error in fetching user copilot fre data',
    CopilotFreDisabled: 'Copilot fre is disabled',
    FrePreviouslyShownAndActionTaken: 'FRE previously shown and action taken',
    FreShownRecently: 'FRE shown recently',
    AdminStatusIsUnPinned: 'Admin status is unpinned',
    Unknown: 'Unknown',
};
export var CopilotRedirectionQueryParams = {
    redirectId: 'redirectId',
    fromCode: 'fromCode',
};
export var logCopilotFunnelEvent = function (eventName, params) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, isCopilotFunnelLoggingEnabled()];
            case 1:
                if ((_a.sent()) === false) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, populateUserDetails()];
            case 2:
                _a.sent();
                updatedParams = appendAdditionalParams(window.location.href, params);
                logFeature({
                    featureName: "CopilotPinFunnel" /* KnownFeatureNames.CopilotPinFunnel */,
                    eventName: eventName,
                    params: updatedParams,
                });
                return [2 /*return*/];
        }
    });
}); };
export var logSourceRedirectionFunnelEvent = function (eventName, redirectionUrl, params) { return __awaiter(void 0, void 0, void 0, function () {
    var updatedParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, isCopilotFunnelLoggingEnabled()];
            case 1:
                if ((_a.sent()) === false) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, populateUserDetails()];
            case 2:
                _a.sent();
                updatedParams = appendAdditionalParams(redirectionUrl, params);
                logFeature({
                    featureName: "CopilotPinFunnel" /* KnownFeatureNames.CopilotPinFunnel */,
                    eventName: eventName,
                    params: updatedParams,
                });
                return [2 /*return*/];
        }
    });
}); };
export var logImageLoadPerformance = function (imageName, startTime) {
    logPerformance({
        eventName: "CopilotFre_ImageLoad_".concat(imageName),
        latency: Date.now() - startTime,
    });
};
export var logTelemetryOnUnload = function () {
    var params = {};
    var updatedParams = appendAdditionalParams(window.location.href, params);
    logFeature({
        featureName: "CopilotPinFunnel" /* KnownFeatureNames.CopilotPinFunnel */,
        eventName: 'OnPageUnload',
        params: updatedParams,
    });
};
/**
 * Logs telemetry data based on the visibility state of the page.
 * The `visibilitychange` event is triggered in the following scenarios:
 *
 * 1. **Tab Switching**: When the user switches to a different browser tab, the visibility state changes to 'hidden'.
 *    When they switch back, it changes to 'visible'.
 *
 * 2. **Minimizing the Browser**: When the browser window is minimized, the visibility state changes to 'hidden'.
 *    When it is restored, the state changes back to 'visible'.
 *
 * 3. **Switching Applications**: When the user switches to a different application, the browser's visibility state changes to 'hidden'.
 *    When they return to the browser, it changes back to 'visible'.
 *
 * 4. **Locking the Screen**: When the user locks their computer screen, the visibility state changes to 'hidden'.
 *    When they unlock the screen, it changes back to 'visible'.
 *
 * 5. **Closing the Browser**: When the browser is closed, the visibility state changes to 'hidden'.
 *
 * Page Visibility API Limitations: Some scenarios, like closing a tab, might not always guarantee that visibilitychange will fire in every browser.
 */
export var logTelemetryOnPageVisibilityChange = function () {
    var params = {};
    var updatedParams = appendAdditionalParams(window.location.href, params);
    var eventName = 'OnPageVisibilityUnknown';
    if (document.visibilityState === 'hidden') {
        eventName = 'OnPageHidden';
    }
    else if (document.visibilityState === 'visible') {
        eventName = 'OnPageVisible';
    }
    logFeature({
        featureName: "CopilotPinFunnel" /* KnownFeatureNames.CopilotPinFunnel */,
        eventName: eventName,
        params: updatedParams,
    });
};
var appendAdditionalParams = function (urlForRedirectionParams, params) {
    var _a, _b, _c, _d;
    var urlLocation = (_b = (_a = getLocation(urlForRedirectionParams)) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '';
    var queryParams = getQueryParams(urlLocation);
    var queryParamsWithLowerCaseKeys = convertQueryParamKeysToLowerCase(queryParams);
    var RedirectId = (_c = queryParamsWithLowerCaseKeys[CopilotRedirectionQueryParams.redirectId.toLowerCase()]) !== null && _c !== void 0 ? _c : '';
    var RedirectionSourceApp = (_d = queryParamsWithLowerCaseKeys[CopilotRedirectionQueryParams.fromCode.toLowerCase()]) !== null && _d !== void 0 ? _d : '';
    var AADId = userData.aadId;
    var TenantId = userData.tenantId;
    var BaseUrl = window.location.origin;
    var updatedParams = __assign(__assign({}, params), { RedirectId: RedirectId, RedirectionSourceApp: RedirectionSourceApp, AADId: AADId, TenantId: TenantId, BaseUrl: BaseUrl });
    return updatedParams;
};
var isCopilotFunnelLoggingEnabled = function () { return __awaiter(void 0, void 0, void 0, function () {
    var featureGatesResult, featureGates, _a;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!(copilotFunnelLoggingEnabled === undefined)) return [3 /*break*/, 4];
                featureGatesResult = getFeatureGates();
                if (!(featureGatesResult === null || featureGatesResult === void 0 ? void 0 : featureGatesResult.result)) return [3 /*break*/, 1];
                _a = featureGatesResult;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, fetchFeatureGates()];
            case 2:
                _a = _e.sent();
                _e.label = 3;
            case 3:
                featureGates = _a;
                copilotFunnelLoggingEnabled =
                    (_d = (_c = (_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.result) === null || _b === void 0 ? void 0 : _b.copilotFreGates) === null || _c === void 0 ? void 0 : _c.copilotFreEnabled) !== null && _d !== void 0 ? _d : false;
                _e.label = 4;
            case 4: return [2 /*return*/, copilotFunnelLoggingEnabled];
        }
    });
}); };
var populateUserDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
    var identityResult, identity, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!(userData.aadId === '' || userData.tenantId === '')) return [3 /*break*/, 4];
                identityResult = getOfficeIdentity();
                if (!identityResult) return [3 /*break*/, 1];
                _a = identityResult;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, fetchIdentity()];
            case 2:
                _a = _b.sent();
                _b.label = 3;
            case 3:
                identity = _a;
                userData = {
                    aadId: identity.objectId,
                    tenantId: identity.tenantId,
                };
                _b.label = 4;
            case 4: return [2 /*return*/];
        }
    });
}); };
var convertQueryParamKeysToLowerCase = function (queryParams) {
    var updatedQueryParams = {};
    for (var key in queryParams) {
        updatedQueryParams[key.toLowerCase()] = queryParams[key].toString();
    }
    return updatedQueryParams;
};
//# sourceMappingURL=telemetry.js.map